import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaDashboardsComponent } from './plataforma-dashboards.component';
import { CabecalhoDireitaModule } from '../../components/cabecalho/cabecalho-direita/cabecalho-direita.module';
import { BeneficioCompletoModule } from '../../components/beneficio/beneficio-completo/beneficio-completo.module';

@NgModule({
  declarations: [
    PlataformaDashboardsComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoDireitaModule,
    BeneficioCompletoModule
  ],
  exports: [
    PlataformaDashboardsComponent
  ]
})

export class PlataformaDashboardsModule { }
